import { Link } from "react-router-dom";
import { SERVICES_CARDS_DATA_LIST } from "../../utils/defaults";
import BlueTag from "../common/ui/BlueTag";
import Heading from "../common/ui/Heading";
import Paragraph from "../common/ui/Paragraph";

const OurServices = () => {
  return (
    <section className="py-[85px] md:py-[100px] xl:py-[140px]">
      <div className="container">
        <div className="sm:text-center pb-1">
          <BlueTag center={{ ">": 640 }}>Our Services</BlueTag>
        </div>
        <Heading className=" sm:text-center" center>
          Explore Our Expert Business Solutions
        </Heading>
        <div className="mt-10 md:mt-[60px]  grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
          {SERVICES_CARDS_DATA_LIST.map((service, index) => (
            <Link to={service.url}>
              <div
                key={index}
                className="flex max-sm:flex-col max-sm:min-h-[348px] sm:justify-between items-center max-sm:w-fit gap-3 sm:gap-6 w-full max-lg:max-w-[714px] max-lg:mx-auto group duration-300 hover:shadow-none ease-linear transition-all sm:pl-5 py-4 px-4 sm:pr-[35px] lg:p-4 bg-white shadow-serviceCard rounded-2xl gradient-green-border"
              >
                <div className="h-[162px] sm:h-[220px] overflow-clip rounded-md max-w-[304px] lg:max-w-[196px] 2xl:max-w-full w-full">
                  <img
                    src={service.image}
                    alt={service.title}
                    className=" w-full group-hover:scale-105 object-top h-[162px] sm:h-[220px] pointer-events-none object-cover rounded-md"
                  />
                </div>
                <div className="max-w-[302px] w-full">
                  <h3 className="text-lg font-bold text-custom-dark-blue !leading-133">
                    {service.title}
                  </h3>
                  <Paragraph className="mt-2.5 sm:mt-3.5 ">
                    {service.description}
                  </Paragraph>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurServices;
